import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useSearchParams, useNavigate} from "react-router-dom";
import {Pagination} from "page/util/Pagination";
import {formatBusinessNumber, formatDate} from "page/util/helpers";

function Main() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paginationDto, setPaginationDto] = useState();
    const [contents, setContents] = useState([]);

    const page = searchParams.get('page') || "1";
    const bizName = searchParams.get('bizName');
    const bizNumber = searchParams.get('bizNumber');
    const membership = searchParams.get('membership');

    const navigate = useNavigate();

    const requestSearch = (e) => {
        const params = {};
        params.page = page;
        params.bizName = bizName
        params.bizNumber = bizNumber
        params.membership = membership;

        axios.get(`/admin/bizs`, { params: params })
            .then((res) => {
                setPaginationDto(res.data);
                setContents(res.data.content);
            });
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams)
    }

    const displayMembershipStatus = (membershipStatus) => {
        switch (membershipStatus) {
            case "UNSUBSCRIBE": return <span style={{color: "gray"}}>미구독</span>
            case "SUBSCRIBE": return <span style={{color: "blue"}}>구독중</span>
            case "SUBSCRIBE_HOLD": return <span style={{color: "red"}}>구독보류</span>
            case "SUBSCRIBE_CANCEL": return <span style={{color: "red"}}>구독취소요청중</span>
            default: return <span style={{color: "gray"}}>미구독</span>
        }
    }

    useEffect(() => {
        requestSearch();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">사업장관리 > 목록</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="card">
                                        <div className="card-tools" style={{marginTop: '40px'}}>
                                            <div className="form-group row" style={{float: "right"}}>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>사업자번호</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '150px'}}
                                                       onChange={ e => {
                                                           searchParams.set('bizNumber', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={bizNumber}
                                                       placeholder=''/>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>사업장명</label>

                                                <input type="text" className="form-control"
                                                       style={{width: '150px'}}
                                                       onChange={ e=> {
                                                           searchParams.set('bizName', e.target.value);
                                                           setSearchParams(searchParams);
                                                       }}
                                                       onKeyDown={e => {
                                                           if (e.key === 'Enter') {
                                                               setPage(1);
                                                               requestSearch();
                                                           }
                                                       }}
                                                       value={bizName}
                                                       placeholder=''/>

                                                <label className="col-sm-auto col-form-label"
                                                       style={{marginLeft: '10px'}}>멤버십</label>

                                                <select className="form-control float-right"
                                                        style={{width: '120px', marginRight: '20px'}}
                                                        onChange={e => {
                                                            searchParams.set('membership', e.target.value);
                                                            setSearchParams(searchParams);
                                                        }}
                                                        value={membership}>
                                                    <option value="">전체</option>
                                                    <option value="BASIC">BASIC</option>
                                                    <option value="BUSINESS">BUSINESS</option>
                                                </select>

                                                <button type="submit" className="btn btn-info float-right"
                                                        style={{width: '80px', marginRight: '10px'}}
                                                        onClick={ () => {
                                                            setPage(1);
                                                            requestSearch();
                                                        }}>
                                                    검색
                                                </button>

                                            </div>
                                        </div>

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <div style={{textAlign: 'right', marginRight: '10px', color: 'gray'}}>
                                                총 사업장수: {paginationDto && (paginationDto.totalCount)}
                                            </div>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>사업장명</th>
                                                    <th>사업자번호</th>
                                                    <th>대표자명</th>
                                                    <th>멤버십</th>
                                                    <th>멤버십상태</th>
                                                    <th>EDI 관리번호</th>
                                                    <th>가입일</th>
                                                    <th>사용자수</th>
                                                    <th>탈퇴자수</th>
                                                    <th>보기</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    contents && contents.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.name}</td>
                                                                <td>{formatBusinessNumber(item.number)}</td>
                                                                <td>{item.ceoName}</td>
                                                                <td>{item.membership}</td>
                                                                <td>{displayMembershipStatus(item.membershipStatus)}</td>
                                                                <td>{item.nationalManagementNo}</td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                                <td>{item.users.length}</td>
                                                                <td>{item.userDrops.length}</td>
                                                                <td>
                                                                    <button type="button"
                                                                            className="btn btn-outline-info">
                                                                        <Link to={`/page/user/biz/detail?bizId=${item.id}`}>보기</Link>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paginationDto && <Pagination pager={paginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}

export default Main;
